import React, {useState, useEffect} from "react";
import {Container, Card} from "react-bootstrap";
import "./VendorAssignment.css";
import axios from "../../util/Axios/AxiosInstance";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as ReactBootStrap from "react-bootstrap";
import filterFactory, {textFilter} from "react-bootstrap-table2-filter";
import edit from "../../../images/edit.png";
import TableActionIcon from "../../util/TableActionIcon";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Skeleton from "react-loading-skeleton";

function VendorAssignmentList({HandleEvent, HandleEventGetId}) {
    const [tableData, setTableData] = useState([{
        date: <Skeleton/>,
        department: <Skeleton/>,
        subDepartment: <Skeleton/>,
        standardMp: <Skeleton/>,
        requirementsTotal: <Skeleton/>,
        shiftA: <Skeleton/>,
        shiftB: <Skeleton/>,
        shiftC: <Skeleton/>,
        general: <Skeleton/>,
        name: <Skeleton/>
    }, {
        date: <Skeleton/>,
        department: <Skeleton/>,
        subDepartment: <Skeleton/>,
        standardMp: <Skeleton/>,
        requirementsTotal: <Skeleton/>,
        shiftA: <Skeleton/>,
        shiftB: <Skeleton/>,
        shiftC: <Skeleton/>,
        general: <Skeleton/>,
        name: <Skeleton/>
    }, {
        date: <Skeleton/>,
        department: <Skeleton/>,
        subDepartment: <Skeleton/>,
        standardMp: <Skeleton/>,
        requirementsTotal: <Skeleton/>,
        shiftA: <Skeleton/>,
        shiftB: <Skeleton/>,
        shiftC: <Skeleton/>,
        general: <Skeleton/>,
        name: <Skeleton/>
    }, {
        date: <Skeleton/>,
        department: <Skeleton/>,
        subDepartment: <Skeleton/>,
        standardMp: <Skeleton/>,
        requirementsTotal: <Skeleton/>,
        shiftA: <Skeleton/>,
        shiftB: <Skeleton/>,
        shiftC: <Skeleton/>,
        general: <Skeleton/>,
        name: <Skeleton/>
    }, {
        date: <Skeleton/>,
        department: <Skeleton/>,
        subDepartment: <Skeleton/>,
        standardMp: <Skeleton/>,
        requirementsTotal: <Skeleton/>,
        shiftA: <Skeleton/>,
        shiftB: <Skeleton/>,
        shiftC: <Skeleton/>,
        general: <Skeleton/>,
        name: <Skeleton/>
    }, {
        date: <Skeleton/>,
        department: <Skeleton/>,
        subDepartment: <Skeleton/>,
        standardMp: <Skeleton/>,
        requirementsTotal: <Skeleton/>,
        shiftA: <Skeleton/>,
        shiftB: <Skeleton/>,
        shiftC: <Skeleton/>,
        general: <Skeleton/>,
        name: <Skeleton/>
    },]);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const current = new Date();
    const date = `${current.getFullYear()}-${current.getMonth() + 1}-${current.getDate()}`;

    const options = {
        onSizePerPageChange: (sizePerPage, page) => {
            setPageSize(sizePerPage);
            // setPageNumber(page);
        }, onPageChange: (page, sizePerPage) => {
            // setPageSize(sizePerPage);
            setPageNumber(page);
        },
    };
    const getCLRDetailsByPlantNameAndDate = async (plantName, date) => {
        try {
            const data = await axios.get("getCLRDetailsByPlantNameAndDate/" + plantName + "/" + date);
            setTableData(data.data);

            setLoading(true);
        } catch (e) {
        }
    };

    useEffect(() => {
        AOS.init();
        const plantName = localStorage.getItem("branchId");
        getCLRDetailsByPlantNameAndDate(plantName, date);
    }, []);

    function doSomething() {

    }

        const columns = [{
            dataField: "id", text: "S No.", formatter: (cell, row, rowIndex) => {
                return (pageNumber - 1) * pageSize + (rowIndex + 1);
            }, headerStyle: (colum, colIndex) => {
                return {width: "60px", textAlign: "center"};
            },
        }, // { dataField: "id", text: "ID" , sort: true, filter: textFilter() },
            // { dataField: "transactionDate", text: "Date", sort: true, filter: textFilter() },
            // { dataField: "deptName", text: "Department",sort: true, filter: textFilter()  },
            // { dataField: "subDeptName", text: "SubDepartment",sort: true, filter: textFilter() },
            // { dataField: "shiftName", text: "Shift",sort: true, filter: textFilter()},
            // { dataField: "vendorName", text: "Vendor",sort: true, filter: textFilter() },
            // { dataField: "maleCount", text: "MaleCount",sort: true, filter: textFilter() },
            // { dataField: "femaleCount", text: "FemaleCount",sort: true, filter: textFilter() },
            {dataField: "date", text: "Date", sort: true, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`}, {
                dataField: "department", text: "Department", sort: true, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`,
            }, {
                dataField: "subDepartment", text: "SubDepartment", sort: true, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`,
            }, {
                dataField: "standardMp", text: "Standard MP", sort: true, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`,
            }, {
                dataField: "requirementsTotal", text: "Requirements Total", sort: true, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`,
            }, {dataField: "shiftA", text: "Shift A", sort: true, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`}, {
                dataField: "shiftB",
                text: "Shift B",
                sort: true,
                filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`,
            }, {dataField: "shiftC", text: "Shift C", sort: true, filter: textFilter(), title: (cell, row, rowIndex, colIndex) => `${cell}`,}, {
                dataField: "general",
                text: "General",
                sort: true,
                filter: textFilter(),
                title: (cell, row, rowIndex, colIndex) => `${cell}`,
            }, {
                dataField: "name", text: "Actions", isDummyField: true, formatter: (cellContent, row) => {
                    return (
                        <TableActionIcon
                            src={edit}
                            title="Edit CL request"
                            disabled={!loading}
                            onClick={() => HandleEventGetId(7.1, row)}
                        />
                    );
                },
            }, // { dataField: "name", text: "Requested By",sort: true, filter: textFilter() },
        ];

    return (<Card className="cardStyl">
        <Container fluid className="px-0">
            <div className={"mt-2"}>
                {/*<h2>Laborer Master</h2>*/}
                <h5 className={"priColor"}>CL Requests </h5>
            </div>
            <div>
                {/* <div className={"row"}>
                    <div style={{marginBottom:"10px"}}> */}
                {/*<button className={"btn btn-primary"} variant="primary"*/}
                {/*        style={{ float: "left" }}*/}
                {/*        >*/}
                {/*    Filter*/}
                {/*</button>*/}
                {/* <button className={"btn btn-primary"} variant="primary"
                                style={{ float: "right" }}
                                onClick={(e)=> HandleEvent(7.1)}>
                            Add New
                        </button>

                    </div>
                </div> */}
                <div></div>
                <div data-aos="zoom-in-right" data-aos-duration="550">
                    <BootstrapTable
                        bootstrap4
                        keyField="id"
                        data={tableData}
                        columns={columns}
                        wrapperClasses="table-responsive"
                        pagination={paginationFactory(options)}
                        filter={filterFactory()}
                    />
                </div>
            </div>
        </Container>
    </Card>);
}

export default VendorAssignmentList;
